import { render, staticRenderFns } from "./editVisible.vue?vue&type=template&id=6578ba1c"
import script from "./editVisible.vue?vue&type=script&lang=js"
export * from "./editVisible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6578ba1c')) {
      api.createRecord('6578ba1c', component.options)
    } else {
      api.reload('6578ba1c', component.options)
    }
    module.hot.accept("./editVisible.vue?vue&type=template&id=6578ba1c", function () {
      api.rerender('6578ba1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsVisible/editVisible.vue"
export default component.exports